import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Box, Typography } from "@mui/material";
import { formatarCnpj, fmtMesAno } from "../utils";
import { formatarMoedaBRL } from "../Detalhe/utils/calcularTotaisPorAno.util";
import { formatarQuantidadeLancamentos } from "../Detalhe/utils/formatarQuantidade.util";

/**
 * TXM-477 — modal "Detalhes do cruzamento ICMS-ST", 15 campos (ver card e o protótipo
 * apuracao_icms_st_detalhes.html). Diferente do mockup do protótipo (que assume 1 valor por
 * campo), Prodid/CST entrada aqui podem trazer MAIS de um valor: quando uma saída é coberta
 * por várias entradas (rateio por média ponderada), o motor lista todas as entradas
 * distintas que contribuíram (decisão do usuário, 2026-09-16) em vez de escolher uma só.
 */
function listaOuTraco(valores) {
  if (!Array.isArray(valores) || valores.length === 0) return "—";
  return valores.join(", ");
}

function Campo({ label, children }) {
  return (
    <Box>
      <Typography sx={{ fontSize: "0.7rem", fontWeight: 600, color: "#757575", textTransform: "uppercase", letterSpacing: "0.4px" }}>
        {label}
      </Typography>
      <Typography sx={{ fontSize: "0.9rem", color: "#1b3a5f", fontWeight: 500, mt: 0.25, wordBreak: "break-word" }}>
        {children}
      </Typography>
    </Box>
  );
}

export default function ModalDetalhesCruzamentoIcmsSt({ open, onClose, linha, cnpj }) {
  if (!linha) return null;

  const semEntrada = (Number(linha.qtdSemEntrada) || 0) > 0;
  const comProblema = (Number(linha.qtdComProblema) || 0) > 0;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Detalhes do cruzamento ICMS-ST</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, py: 1 }}>
          <Campo label="CNPJ">{formatarCnpj(cnpj)}</Campo>
          <Campo label="Competência">{fmtMesAno(String(linha.competencia || "").slice(0, 7))}</Campo>
          <Campo label="Modelo">{linha.modeloDocumento || "—"}</Campo>
          <Campo label="NCM">{linha.ncm || "—"}</Campo>
          <Campo label="EAN/GTIN">{linha.ean || "—"}</Campo>
          <Campo label="Prodid entrada">{listaOuTraco(linha.prodidsEntrada)}</Campo>
          <Campo label="Prodid saída">{listaOuTraco(linha.prodidsSaida)}</Campo>
          <Campo label="CST entrada">{listaOuTraco(linha.cstsEntrada)}</Campo>
          <Campo label="CST saída">{listaOuTraco(linha.cstsSaida)}</Campo>
          <Campo label="Base total entrada">{formatarMoedaBRL(linha.baseEntrada)}</Campo>
          <Campo label="Base total saída">{formatarMoedaBRL(linha.baseSaida)}</Campo>
          <Campo label="Crédito">{formatarMoedaBRL(linha.credito)}</Campo>
          <Campo label="Status da correlação">{semEntrada ? "Sem entrada" : "Cruzada"}</Campo>
          <Campo label="Fator de conversão com problema">{comProblema ? "Sim" : "Não"}</Campo>
          <Campo label="Quantidade de cruzamentos">{formatarQuantidadeLancamentos(linha.qtdCruzamentos)}</Campo>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">Fechar</Button>
      </DialogActions>
    </Dialog>
  );
}
